var map = {
	"./audio/mute.svg": 508,
	"./audio/mute_blue.svg": 140,
	"./audio/mute_red.svg": 98,
	"./audio/mute_sky.svg": 213,
	"./audio/mute_white.svg": 146,
	"./audio/volume.svg": 509,
	"./audio/volume_blue.svg": 141,
	"./audio/volume_red.svg": 99,
	"./audio/volume_sky.svg": 214,
	"./audio/volume_white.svg": 147,
	"./banner/ball-backgroud.png": 258,
	"./banner/banner_lotto5.svg": 259,
	"./banner/lottery5_banner.png": 260,
	"./banner/lottery5_banner_MHSB999.png": 261,
	"./banner/lottery5_banner_MHSBGREEN.png": 262,
	"./data-found.gif": 263,
	"./flags/cambodia-round.svg": 245,
	"./flags/cambodia.svg": 162,
	"./flags/chinese.svg": 164,
	"./flags/singapore.svg": 510,
	"./flags/thailand.svg": 165,
	"./flags/united-state.svg": 163,
	"./flags/vietname.svg": 166,
	"./home/Lotto12.jpg": 264,
	"./home/Lotto12.png": 511,
	"./home/Lotto5.jpg": 265,
	"./home/Lotto5.png": 512,
	"./home/Lotto6.jpg": 266,
	"./home/Lotto6.png": 513,
	"./home/Lotto90.jpg": 267,
	"./home/Lotto99.png": 268,
	"./home/call_center.png": 514,
	"./home/line-footer.png": 515,
	"./home/lo12.png": 269,
	"./home/lo12v2.png": 270,
	"./home/lo1v36.png": 271,
	"./home/lo5.png": 272,
	"./home/lo5d.png": 273,
	"./home/lo6.png": 274,
	"./home/lo90.png": 275,
	"./icons/5d.svg": 516,
	"./icons/about-us.svg": 517,
	"./icons/clock.svg": 518,
	"./icons/home.svg": 519,
	"./icons/how-to-play.svg": 520,
	"./icons/mute.svg": 521,
	"./icons/next.svg": 522,
	"./icons/result.svg": 523,
	"./icons/ticket-white.svg": 524,
	"./icons/ticket.svg": 525,
	"./icons/volume.svg": 526,
	"./jackpot/1": 276,
	"./jackpot/1.gif": 527,
	"./jackpot/1.json": 276,
	"./jackpot/2": 277,
	"./jackpot/2.gif": 528,
	"./jackpot/2.json": 277,
	"./jackpot/2.png": 278,
	"./jackpot/3": 279,
	"./jackpot/3.gif": 529,
	"./jackpot/3.json": 279,
	"./jackpot/3.png": 280,
	"./jackpot/4": 281,
	"./jackpot/4.gif": 530,
	"./jackpot/4.json": 281,
	"./jackpot/4.png": 282,
	"./jackpot/5": 283,
	"./jackpot/5.gif": 531,
	"./jackpot/5.json": 283,
	"./jackpot/5.png": 284,
	"./jackpot/loading": 285,
	"./jackpot/loading.json": 285,
	"./jackpot/show/10.gif": 532,
	"./jackpot/show/15.gif": 533,
	"./jackpot/show/2.gif": 534,
	"./jackpot/show/3.gif": 535,
	"./jackpot/show/4.gif": 536,
	"./jackpot/show/5.gif": 537,
	"./jackpot/v2/2.png": 169,
	"./jackpot/v2/3.png": 170,
	"./jackpot/v2/4.png": 171,
	"./jackpot/v2/5.png": 172,
	"./jackpot/v2/border-jackpot.png": 84,
	"./keno/Loading_Linear.gif": 286,
	"./keno/bg.png": 538,
	"./lo5d/lotto5d_bg.png": 539,
	"./lo5d/post/lo5d_post_A.png": 540,
	"./lo5d/post/lo5d_post_A.svg": 287,
	"./lo5d/post/lo5d_post_B.png": 541,
	"./lo5d/post/lo5d_post_B.svg": 288,
	"./lo5d/post/lo5d_post_C.png": 542,
	"./lo5d/post/lo5d_post_C.svg": 289,
	"./lo5d/post/lo5d_post_D.png": 543,
	"./lo5d/post/lo5d_post_D.svg": 290,
	"./lo5d/result/0.svg": 544,
	"./lo5d/result/1.svg": 545,
	"./lo5d/result/2.svg": 546,
	"./lo5d/result/3.svg": 547,
	"./lo5d/result/4.svg": 548,
	"./lo5d/result/5.svg": 549,
	"./lo5d/result/6.svg": 550,
	"./lo5d/result/7.svg": 551,
	"./lo5d/result/8.svg": 552,
	"./lo5d/result/9.svg": 553,
	"./logo/BCT168.png": 132,
	"./logo/KPW.png": 173,
	"./logo/LMHSB168.png": 174,
	"./logo/MHSB168.png": 175,
	"./logo/MHSB999.png": 291,
	"./logo/MHSBC.png": 292,
	"./logo/MHSBGREEN.png": 293,
	"./logo/MHSBKP.png": 294,
	"./logo/MT168.png": 295,
	"./logo/ONLINEP99.png": 296,
	"./logo/P99.png": 297,
	"./logo/SBS636.png": 298,
	"./logo/facebook.svg": 176,
	"./logo/fullscreen.svg": 177,
	"./logo/logo-en.png": 178,
	"./logo/logo2.png": 299,
	"./logo/youtube.svg": 179,
	"./lotto12/888": 180,
	"./lotto12/888.json": 180,
	"./lotto12/888.png": 300,
	"./lotto12/BCT168": 181,
	"./lotto12/BCT168.json": 181,
	"./lotto12/BCT168.png": 301,
	"./lotto12/KPW": 182,
	"./lotto12/KPW.json": 182,
	"./lotto12/KPW.png": 302,
	"./lotto12/LMHSB168": 183,
	"./lotto12/LMHSB168.json": 183,
	"./lotto12/LMHSB168.png": 303,
	"./lotto12/MHSB168": 184,
	"./lotto12/MHSB168.json": 184,
	"./lotto12/MHSB168.png": 304,
	"./lotto12/MHSB999": 185,
	"./lotto12/MHSB999.json": 185,
	"./lotto12/MHSB999.png": 305,
	"./lotto12/MHSBC": 186,
	"./lotto12/MHSBC.json": 186,
	"./lotto12/MHSBC.png": 306,
	"./lotto12/MHSBGREEN": 187,
	"./lotto12/MHSBGREEN.json": 187,
	"./lotto12/MHSBGREEN.png": 307,
	"./lotto12/ONLINEP99": 188,
	"./lotto12/ONLINEP99.json": 188,
	"./lotto12/ONLINEP99.png": 308,
	"./lotto12/P99": 189,
	"./lotto12/P99.json": 189,
	"./lotto12/P99.png": 309,
	"./lotto12/SBS636": 190,
	"./lotto12/SBS636.json": 190,
	"./lotto12/SBS636.png": 310,
	"./lotto12/cards/no-price/kp/EIGHT.png": 311,
	"./lotto12/cards/no-price/kp/ELEVEN.png": 312,
	"./lotto12/cards/no-price/kp/FIVE.png": 313,
	"./lotto12/cards/no-price/kp/FOUR.png": 314,
	"./lotto12/cards/no-price/kp/NINE.png": 315,
	"./lotto12/cards/no-price/kp/ONE.png": 316,
	"./lotto12/cards/no-price/kp/SEVEN.png": 317,
	"./lotto12/cards/no-price/kp/SIX.png": 318,
	"./lotto12/cards/no-price/kp/TEN.png": 319,
	"./lotto12/cards/no-price/kp/THREE.png": 320,
	"./lotto12/cards/no-price/kp/TWELVE.png": 321,
	"./lotto12/cards/no-price/kp/TWO.png": 322,
	"./lotto12/cards/no-price/normal/v1/EIGHT.png": 323,
	"./lotto12/cards/no-price/normal/v1/ELEVEN.png": 324,
	"./lotto12/cards/no-price/normal/v1/FIVE.png": 325,
	"./lotto12/cards/no-price/normal/v1/FOUR.png": 326,
	"./lotto12/cards/no-price/normal/v1/NINE.png": 327,
	"./lotto12/cards/no-price/normal/v1/ONE.png": 328,
	"./lotto12/cards/no-price/normal/v1/SEVEN.png": 329,
	"./lotto12/cards/no-price/normal/v1/SIX.png": 330,
	"./lotto12/cards/no-price/normal/v1/TEN.png": 331,
	"./lotto12/cards/no-price/normal/v1/THREE.png": 332,
	"./lotto12/cards/no-price/normal/v1/TWELVE.png": 333,
	"./lotto12/cards/no-price/normal/v1/TWO.png": 334,
	"./lotto12/cards/no-price/normal/v2/EIGHT.png": 335,
	"./lotto12/cards/no-price/normal/v2/ELEVEN.png": 336,
	"./lotto12/cards/no-price/normal/v2/FIVE.png": 337,
	"./lotto12/cards/no-price/normal/v2/FOUR.png": 338,
	"./lotto12/cards/no-price/normal/v2/NINE.png": 339,
	"./lotto12/cards/no-price/normal/v2/ONE.png": 340,
	"./lotto12/cards/no-price/normal/v2/SEVEN.png": 341,
	"./lotto12/cards/no-price/normal/v2/SIX.png": 342,
	"./lotto12/cards/no-price/normal/v2/TEN.png": 343,
	"./lotto12/cards/no-price/normal/v2/THREE.png": 344,
	"./lotto12/cards/no-price/normal/v2/TWELVE.png": 345,
	"./lotto12/cards/no-price/normal/v2/TWO.png": 346,
	"./lotto12/cards/no-price/normal/v3/EIGHT.png": 347,
	"./lotto12/cards/no-price/normal/v3/ELEVEN.png": 348,
	"./lotto12/cards/no-price/normal/v3/FIVE.png": 349,
	"./lotto12/cards/no-price/normal/v3/FOUR.png": 350,
	"./lotto12/cards/no-price/normal/v3/NINE.png": 351,
	"./lotto12/cards/no-price/normal/v3/ONE.png": 352,
	"./lotto12/cards/no-price/normal/v3/SEVEN.png": 353,
	"./lotto12/cards/no-price/normal/v3/SIX.png": 354,
	"./lotto12/cards/no-price/normal/v3/TEN.png": 355,
	"./lotto12/cards/no-price/normal/v3/THREE.png": 356,
	"./lotto12/cards/no-price/normal/v3/TWELVE.png": 357,
	"./lotto12/cards/no-price/normal/v3/TWO.png": 358,
	"./lotto12/slots/BLUE.png": 359,
	"./lotto12/slots/GREEN.png": 360,
	"./lotto12/slots/ODD.png": 361,
	"./lotto12/slots/OVER.png": 362,
	"./lotto12/slots/UNDER.png": 363,
	"./lotto12/slots/no-price/BLUE.png": 364,
	"./lotto12/slots/no-price/EVEN.png": 365,
	"./lotto12/slots/no-price/GREEN.png": 366,
	"./lotto12/slots/no-price/ODD.png": 367,
	"./lotto12/slots/no-price/OVER.png": 368,
	"./lotto12/slots/no-price/RED.png": 369,
	"./lotto12/slots/no-price/UNDER.png": 370,
	"./lotto12v2/bg-light-1.png": 554,
	"./lotto12v2/bg-light-2.png": 555,
	"./lotto12v2/cards/1.png": 556,
	"./lotto12v2/cards/10.png": 557,
	"./lotto12v2/cards/11.png": 558,
	"./lotto12v2/cards/12.png": 559,
	"./lotto12v2/cards/2.png": 560,
	"./lotto12v2/cards/3.png": 561,
	"./lotto12v2/cards/4.png": 562,
	"./lotto12v2/cards/5.png": 563,
	"./lotto12v2/cards/6.png": 564,
	"./lotto12v2/cards/7.png": 565,
	"./lotto12v2/cards/8.png": 566,
	"./lotto12v2/cards/9.png": 567,
	"./lotto12v2/cards/active/1.png": 568,
	"./lotto12v2/cards/active/10.png": 569,
	"./lotto12v2/cards/active/11.png": 570,
	"./lotto12v2/cards/active/12.png": 571,
	"./lotto12v2/cards/active/2.png": 572,
	"./lotto12v2/cards/active/3.png": 573,
	"./lotto12v2/cards/active/4.png": 574,
	"./lotto12v2/cards/active/5.png": 575,
	"./lotto12v2/cards/active/6.png": 576,
	"./lotto12v2/cards/active/7.png": 577,
	"./lotto12v2/cards/active/8.png": 578,
	"./lotto12v2/cards/active/9.png": 579,
	"./lotto12v2/exit_fullscreen.png": 580,
	"./lotto12v2/fullscreen.png": 581,
	"./lotto12v2/signs/1.png": 582,
	"./lotto12v2/signs/10.png": 583,
	"./lotto12v2/signs/11.png": 584,
	"./lotto12v2/signs/12.png": 585,
	"./lotto12v2/signs/2.png": 586,
	"./lotto12v2/signs/3.png": 587,
	"./lotto12v2/signs/4.png": 588,
	"./lotto12v2/signs/5.png": 589,
	"./lotto12v2/signs/6.png": 590,
	"./lotto12v2/signs/7.png": 591,
	"./lotto12v2/signs/8.png": 592,
	"./lotto12v2/signs/9.png": 593,
	"./lotto12v2/zodiac_bg@1x.a104956b.png": 115,
	"./lotto12v2/zodiac_border.png": 215,
	"./lotto12v2/zodiac_left_bg.png": 216,
	"./lotto12v3/arrow.png": 217,
	"./lotto12v3/logo-arrow.png": 594,
	"./lotto12v3/lucky-wheel-img-0.png": 595,
	"./lotto12v3/lucky-wheel-img-1.png": 596,
	"./lotto12v3/lucky-wheel-img-10.png": 597,
	"./lotto12v3/lucky-wheel-img-11.png": 598,
	"./lotto12v3/lucky-wheel-img-12.png": 599,
	"./lotto12v3/lucky-wheel-img-2.png": 600,
	"./lotto12v3/lucky-wheel-img-3.png": 601,
	"./lotto12v3/lucky-wheel-img-4.png": 602,
	"./lotto12v3/lucky-wheel-img-5.png": 603,
	"./lotto12v3/lucky-wheel-img-6.png": 604,
	"./lotto12v3/lucky-wheel-img-7.png": 605,
	"./lotto12v3/lucky-wheel-img-8.png": 606,
	"./lotto12v3/lucky-wheel-img-9.png": 607,
	"./lotto12v3/lucky_border1.png": 608,
	"./lotto12v3/lucky_border2.png": 609,
	"./lotto12v3/zodiac_border.png": 148,
	"./lotto5/Loading999.gif": 371,
	"./lotto5/Loading_Linear.gif": 372,
	"./lotto5/banner.svg": 610,
	"./lotto5/logo-999.png": 611,
	"./lotto5/logo-kpw.png": 612,
	"./lotto5/logo.png": 373,
	"./lotto5/logo_white.png": 613,
	"./lotto90/logo.png": 374,
	"./lotto90/lotto90_drawing_bg.png": 116,
	"./lotto90/lotto90_v1_bg.png": 142,
	"./lotto99/bg-circle.png": 614,
	"./lotto99/bg-white-circle.png": 615,
	"./lotto99/bg99select1.png": 117,
	"./lotto99/checked-box.png": 616,
	"./lotto99/checked-post.png": 617,
	"./lotto99/code_number_bg.png": 618,
	"./lotto99/deng1.png": 619,
	"./lotto99/deng2.png": 620,
	"./lotto99/download (3).png": 621,
	"./lotto99/download.png": 622,
	"./lotto99/groups_bg.png": 118,
	"./lotto99/logo.png": 623,
	"./lotto99/mark99_logo.png": 624,
	"./lotto99/num99_bg.png": 625,
	"./lotto99/uncheck-box.png": 626,
	"./printer.svg": 627,
	"./refresh-circle.svg": 375,
	"./refresh-white.svg": 376,
	"./refresh.svg": 377,
	"./results/BLUE.png": 628,
	"./results/EVEN.png": 629,
	"./results/GREEN.png": 630,
	"./results/ODD.png": 631,
	"./results/OVER.png": 632,
	"./results/RED.png": 633,
	"./results/UNDER.png": 634,
	"./roulette/backimage.jpg": 635,
	"./roulette/roulette1.png": 636,
	"./roulette/roulette2.png": 637,
	"./roulette/roulette3.png": 638,
	"./roulette/roulette4.png": 639,
	"./roulette/spinner.png": 640,
	"./roulette/top.png": 641,
	"./roulette/wheel.png": 642,
	"./user/default.jpg": 643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 507;